import "./profile.css";
import { routes } from "../../routes";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

function ProfilePagesWrapper() {
  const location = useLocation();
  const [hasFreeBox, setHasFreeBox] = useState(false);
  const user = useSelector((state) => state?.auth?.user);
  const [accordionOpen, setAccordionOpen] = useState(false);

  const tabs = [
    { label: "Account Info", path: "", end: true },
    { label: "Documents", path: "documents" },
    { label: "Fairness", path: "fairness" },
    { label: "Transactions", path: "transactions" },
    { label: "Top-Ups", path: "topups" },
    { label: "Withdrawals", path: "withdrawals" },
    {
      label: hasFreeBox ? "Free Boxes" : "Unbox",
      path: hasFreeBox ? "free-boxes" : routes.UNBOXES,
    },
    { label: "Game History", path: "game-history" },
  ];

  const activeTab =
    tabs.find((tab) => {
      const segments = location.pathname.split("/").filter(Boolean);
      const last = segments[segments.length - 1] || "";
      if (tab.end)
        return last === "" || !tabs.slice(1).some((t) => last === t.path);
      return last === tab.path;
    }) || tabs[0];

  useEffect(() => {
    if (user?.free_boxes && user?.free_boxes_remaining > 0) {
      setHasFreeBox(true);
    }
  }, []);

  return (
    <div className="pfw-profile-wrapper mt-16px">
      {/* ── Desktop horizontal tabs ── */}
      <div className="pfw-profile-tabs pfw-desktop-tabs">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            end={tab.end}
            className={({ isActive }) =>
              `d-center pfw-profile-tab ${isActive ? "active" : ""}`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      {/* ── Mobile / Tablet accordion ── */}
      <div className="pfw-mobile-accordion">
        <button
          className="pfw-accordion-header"
          onClick={() => setAccordionOpen((o) => !o)}
        >
          <span>{activeTab.label}</span>
          <svg
            className={`pfw-accordion-chevron ${accordionOpen ? "open" : ""}`}
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {accordionOpen && (
          <div className="pfw-accordion-body">
            {tabs.map((tab) => (
              <NavLink
                key={tab.path}
                to={tab.path}
                end={tab.end}
                className={({ isActive }) =>
                  `pfw-accordion-item ${isActive ? "active" : ""}`
                }
                onClick={() => setAccordionOpen(false)}
              >
                {tab.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>

      <div className="pfw-profile-content">
        <Outlet />
      </div>
    </div>
  );
}

export default ProfilePagesWrapper;
